"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToStart() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section className="relative overflow-hidden bg-background py-20">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/cta_wave_gradient.png" alt="" className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl opacity-20" />
      </div>

      {}
      <div ref={ref} className={`
          relative z-10 max-w-2xl mx-auto px-6 text-center
          transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)]
          ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}
        `}>
        <h2 className="text-4xl md:text-5xl font-display font-bold text-foreground mb-6">
          Ready to Start?
        </h2>
        <p className="text-lg text-muted mb-8 max-w-xl mx-auto">
          Get in touch with AA Eagle Plumbing today for fast, reliable, and high-quality service. We're here to help with all your plumbing and mechanical system needs.
        </p>

        <Link to="/ContactPage">
          <Button size="lg" className="
              bg-accent text-foreground-accent font-semibold px-8 py-4 rounded-md
              hover:bg-accent-hover hover:-translate-y-0.5 hover:shadow-medium
              active:bg-accent-active active:translate-y-0
              focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:scale-105
              transition-all duration-[120ms] ease-out
            ">
            Request a Free Estimate
          </Button>
        </Link>
      </div>
    </section>;
}